var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_15636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.121 17.122L21 10.243V4.00098C21 1.79498 19.206 0.00097698 17 0.00097698H7C4.794 -2.30197e-05 3 1.79398 3 3.99998V10.243L9.878 17.122C11.012 18.255 12.988 18.255 14.121 17.122ZM7.319 8.53698C6.915 8.16098 6.891 7.52798 7.267 7.12398C7.644 6.71898 8.278 6.69798 8.68 7.07198L10.531 8.79298C10.8 9.06098 11.197 9.06198 11.442 8.81698L15.305 5.09298C15.703 4.70898 16.336 4.72198 16.719 5.11798C17.103 5.51498 17.091 6.14898 16.694 6.53198L12.843 10.244C12.339 10.748 11.672 11 11.004 11C10.331 11 9.656 10.744 9.143 10.232L7.319 8.53698ZM24 12.708V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V12.708C0 11.962 0.184 11.236 0.5 10.571L8.465 18.537C9.41 19.481 10.665 20.001 12.001 20.001C13.337 20.001 14.592 19.481 15.536 18.537L23.501 10.571C23.817 11.236 24 11.963 24 12.708Z",
    fill: "#55217E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_15636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNotifications);
export default __webpack_public_path__ + "static/media/chat-notifications.fe210dcd.svg";
export { ForwardRef as ReactComponent };